/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/12/2022
 */
import BaseObject from "@shared/BaseObject.js";



export default class ToolsSettings extends BaseObject {

	enabledCoachingTools: string[] = []


	genogramCanEdit: boolean = false
	timelineCanEdit: boolean = false

	constructor() {
		super();
	}

	enableCoachingTool(toolId, isEnabled = true){
		if(isEnabled){
			this.enabledCoachingTools.pushUnique(toolId)
		} else {
			this.enabledCoachingTools.deleteItem(toolId)
		}
	}

	isToolEnabled(toolId){
		return this.enabledCoachingTools.includes(toolId)
	}


}
